import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase/firebaseConfig";
import { doc, setDoc, updateDoc } from "firebase/firestore";

import { useUser } from "../../context/UserContext";

interface EmployeeInfoProps {
    signup: boolean;
}


export const EmployeeInfo: React.FC<EmployeeInfoProps> = ({ signup }) => {

    const { user, userData } = useUser();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [pin, setPin] = useState("");
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (userData) {
            if (userData.firstName) setFirstName(userData.firstName);
            if (userData.lastName) setLastName(userData.lastName);
            if (userData.pin) setPin(userData.pin)

        }
    }, [userData]);

    const handleSignup = async () => {

        if (!signup) {
            //we want to just upade their information not try to sign them up
            try {
                if (user?.uid) {
                    await updateDoc(doc(db, "employees", user.uid), { firstName: firstName, lastName: lastName, pin: pin });
                    alert("Employee Info Updated");
                    navigate("/dashboard");
                }

            } catch (err: any) {
                setError(err.message || "Failed to update account.");
            }
        }


        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            if (!user) {
                throw new Error("User creation failed.");
            }

            await setDoc(doc(db, "employees", user.uid), { firstName, lastName, email, id: user.uid, pin });
            alert("Account created successfully!");
            navigate("/dashboard");
        } catch (err: any) {
            setError(err.message || "Failed to create account.");
        }
    };

    const playerName = userData?.firstName + " " + userData?.lastName

    return (
        <div className="player-container">

            <div className="player-info">

                <h1>{!signup ? "Updating " + playerName : "Sign up"}</h1>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <input
                    className="text-input"
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                />
                <input
                    className="text-input"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                />

                <input
                    placeholder="Pin"
                    type="password"
                    value={pin}
                    onChange={(e) => setPin(e.target.value)}
                    className="text-input"
                />


                {signup ?
                    <input
                        className="text-input"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    /> : null}
                {signup ? <input
                    className="text-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                /> : null}

                <div className="button-container">
                    <button className="sign-up" onClick={handleSignup}>{signup ? "Sign Up" : "Save"}</button>
                    {signup ? <button className="back-to-login" onClick={() => navigate("/")}>Back to Login</button> : null}
                </div>

            </div>
        </div>
    );
};

require('./styles.scss')
